import { RootState } from "../../store/store";
import { useSelector } from "react-redux";
import { useCallback } from "react";
import fetchWrapper from "../../api/fetchWrapper";
import { ENDPOINT } from "../../api/endpoint";
import { getSessionData } from "../../utils/helper";
import { expandCountryFilters } from "../../constants/countryGroups";
import { useCountryGroupMembers } from "../../hooks/useCountryGroupMembers.hook";

export const useGenerateSampleData = () => {
  const { selectedFilter } = useSelector((state: RootState) => state.filter);
  const countryGroupMembers = useCountryGroupMembers();
  const userInfo = getSessionData();

  const buildFilterBody = useCallback(
    () => ({
      selectedRegions: selectedFilter?.selectedRegions ?? [],
      startDate: selectedFilter?.startDate,
      endDate: selectedFilter?.endDate,
      selectedCountries: expandCountryFilters(
        selectedFilter?.selectedCountries,
        countryGroupMembers,
      ),
      selectedAffiliates: expandCountryFilters(
        selectedFilter?.selectedAffiliates,
        countryGroupMembers,
      ),
      selectedProduct: selectedFilter?.selectedProduct ?? [],
    }),
    [selectedFilter, countryGroupMembers],
  );

  const getSampleRecordData = async (recordSampleState: any, userData: any) => {
    const body = {
      ...buildFilterBody(),
      assignReviewType: recordSampleState?.assignReviewType ?? [],
      filteredSetCount: recordSampleState?.filteredSetCount,
      sampledSetCount: recordSampleState?.sampledSetCount,
      sampleId: recordSampleState?.sampleId,
      creatorEmail: userData.email,
      firstName: userData.firstName,
      lastName: userData.lastName,
      userRole: userInfo?.role,
      userId: userInfo?.userId,
      unsupportedLanguage: recordSampleState?.unsupportedLanguage ?? null,
    };
    const response = await fetchWrapper(ENDPOINT.SAMPLE_GENERATION, {
      method: "POST",
      body: JSON.stringify(body),
    });

    return response;
  };

  // countOnly hits the same sampling query, so the shown count matches the pool
  const getSampleRecordCount = useCallback(
    async (unsupportedLanguage: string | null): Promise<number> => {
      const body = {
        ...buildFilterBody(),
        unsupportedLanguage: unsupportedLanguage ?? null,
        countOnly: true,
      };
      const response = await fetchWrapper(ENDPOINT.SAMPLE_GENERATION, {
        method: "POST",
        body: JSON.stringify(body),
      });

      return response?.filtered_record_count ?? 0;
    },
    [buildFilterBody],
  );

  return { getSampleRecordData, getSampleRecordCount };
};
